import * as angular from "angular";
import { configRoute } from "./backup-and-restore.router";
import coreModule from "../core/core.module";
import commonModule from "../common/app.common";
import { BACKUP_AND_RESTORE_SERVICE, BackupAndRestoreService } from "./backup-and-restore.service";

export default angular
    .module("board.web.admin.backupAndRestore", [
        coreModule.name,
        commonModule
    ])
    .config(configRoute)
    .service(BACKUP_AND_RESTORE_SERVICE, BackupAndRestoreService)
    .name;


// WEBPACK FOOTER //
// ./app/backup-and-restore/backup-and-restore.module.ts